<template>
  <v-skeleton-loader
    v-if="!user.name"
    height="40px"
    type="text"
    width="150px" />
  <v-menu
    v-else
    :close-on-content-click="true"
    location="bottom end"
    offset="8">
    <template #activator="{ props: menuProps }">
      <v-hover>
        <template #default="{ isHovering, props: hoverProps }">
          <div
            :class="{ 'bg-grey-lighten-4': isHovering }"
            class="d-flex align-center gap-2 cursor-pointer transition-swing rounded-pill px-2 py-1"
            v-bind="mergeProps(menuProps, hoverProps)">
            <user-avatar size="30" :user="user"></user-avatar>

            <div class="d-flex flex-column">
              <span class="font-size-12 font-weight-bold line-height-1">
                {{ getPersonName(user, { initials: true }) }}
              </span>
              <span class="text-disabled font-size-13">{{ user.post }}</span>
            </div>

            <v-icon
              :class="{ 'rotate-180': menuProps['aria-expanded'] === 'true' }"
              size="14">
              mdi-chevron-down
            </v-icon>
          </div>
        </template>
      </v-hover>
    </template>

    <v-list class="pa-1 rounded-xl" density="compact" width="280">
      <v-list-item class="px-3 py-2" disabled style="opacity: 1 !important">
        <template #prepend>
          <user-avatar :user="user" size="40"></user-avatar>
        </template>
        <v-list-item-title class="text-subtitle-2 font-weight-bold">
          {{ getPersonName(user, { initials: true }) }}
        </v-list-item-title>
        <v-list-item-subtitle class="link font-weight-bold font-size-13">
          {{ user.email || 'Електронна адреса відсутня' }}
        </v-list-item-subtitle>
      </v-list-item>

      <v-divider class="my-1" />

      <v-list-item
        v-for="action in mainActions"
        :key="action.command"
        class="rounded-md px-3"
        link
        @click="handleUserAction(action.command)">
        <template #prepend>
          <v-sheet
            class="d-flex align-center justify-center mr-3"
            color="grey-lighten-4"
            height="36"
            rounded="lg"
            width="36">
            <v-icon :icon="action.icon" color="grey-darken-1" size="18" />
          </v-sheet>
        </template>

        <v-list-item-title class="text-body-2 font-weight-medium">
          {{ action.label }}
        </v-list-item-title>
        <v-list-item-subtitle class="text-disabled">
          {{ action.subtitle }}
        </v-list-item-subtitle>
      </v-list-item>

      <v-divider class="my-1" />

      <v-list-item
        v-if="logoutAction"
        class="rounded-md px-3 my-2"
        link
        @click="handleUserAction(logoutAction.command)">
        <template #prepend>
          <v-sheet
            class="d-flex align-center justify-center mr-3"
            color="red-lighten-5"
            height="36"
            rounded="lg"
            width="36">
            <v-icon color="error" icon="mdi-logout" size="18" />
          </v-sheet>
        </template>
        <v-list-item-title class="text-error text-body-2 font-weight-bold">
          {{ logoutAction.label }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { useUserActions } from './userActions.js'
import { computed, mergeProps } from 'vue'
import { getPersonName } from 'best-modules/utils/helpers'
import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'UserActions',
  components: { UserAvatar },
  methods: { mergeProps, getPersonName },
  setup() {
    const { userActions, handleUserAction, user } = useUserActions()

    const mainActions = computed(() =>
      userActions.value.filter(a => a.command !== 'logout')
    )

    const logoutAction = computed(() =>
      userActions.value.find(a => a.command === 'logout')
    )

    return {
      user,
      mainActions,
      logoutAction,
      handleUserAction,
    }
  },
}
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
.line-height-1 {
  line-height: 1.2;
}
</style>
